import { render, staticRenderFns } from "./ProcessDesigner.vue?vue&type=template&id=15ffe113"
import script from "./ProcessDesigner.vue?vue&type=script&lang=js"
export * from "./ProcessDesigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports